<div fxLayout="column" class="fuse-card badge-mes card-border-top">
    @if (tipo !== "MONEDAS") {
        <mat-icon class="icon-badge secundary-text">loyalty</mat-icon>
    }
    @if (tipo === "MONEDAS") {
        <fa-icon class="icon-badge secundary-text" icon="coins"></fa-icon>
    }
    <div fxLayout="column" fxLayoutAlign="center center" class="p-16">
        @if (tipo === "RECIBIDO" || tipo === "RECIBIDOMEJORA") {
            <h5 class="secundary-text m-0">{{ "index.statistics.obtained" | translate }}</h5>
        }
        @if (tipo === "ENTREGADO" || tipo === "ENTREGADOMEJORA") {
            <h5 class="secundary-text m-0">{{ "index.statistics.given" | translate }}</h5>
        }

        @if (tipo === "MONEDAS") {
            <h5 class="secundary-text m-0">{{ "index.statistics.coins.have" | translate }}</h5>
        }
        <h3 class="font-size-36 mt-4 mb-4">{{ numBadges }}</h3>
        @if (tipo === "RECIBIDO" || tipo === "ENTREGADO") {
            <h5 class="secundary-text m-0">{{ "index.statistics.badges.month" | translate }}</h5>
        }
        @if (tipo === "RECIBIDOMEJORA" || tipo === "ENTREGADOMEJORA") {
            <h5 class="secundary-text m-0">
                {{ "index.statistics.badgesmejoras.month" | translate }}
            </h5>
        }

        @if (tipo === "MONEDAS") {
            <h5 class="secundary-text m-0">{{ "general.coins" | translate }}</h5>
        }
    </div>
</div>
